import { Component, OnInit } from '@angular/core';
import { DepotStockLocation } from '../../models/depot-stock-location.model';
import { ActivatedRoute } from '@angular/router';
import { DepotStockLocationValidatorService } from '../../validators/depot-stock-location-validator.service';
import { DepotStockLocationService } from '../../services/depot-stock-location.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-depot-stock-locations-edit',
    templateUrl: './depot-stock-locations-edit.component.html',
    styleUrls: ['./depot-stock-locations-edit.component.scss'],
    standalone: false
})
export class DepotStockLocationsEditComponent implements OnInit {

  depotStockLocation: DepotStockLocation = new DepotStockLocation();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private validator: DepotStockLocationValidatorService,
    private service: DepotStockLocationService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.load(+params['id']);
    })
  }

  load(id: number): void {
    this.service.getDepotStockLocationById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401){return e;}
      this.isServerError = true;
      return e;
    }))
    .subscribe((location: DepotStockLocation) => {
      this.depotStockLocation = location;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.validator.isValid(this.depotStockLocation)) {
      this.service.updateDepotStockLocation(this.depotStockLocation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }

}
